// extracted by mini-css-extract-plugin
module.exports = {"mainCopyBody":"_a784613f","button":"_effa11f7","linkWrapper":"_c634e172","label":"_5dba8187"};